module.exports = __webpack_public_path__ + "img/022.0425c64a.png";